module.exports = __webpack_public_path__ + "static/media/payjak-logotype-d.f8a1dba3.svg";